<template>
  <canvas ref="chart"></canvas>
</template>
<script>
import F2 from '@antv/f2'
export default {
  name: 'chart',
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.chart = new F2.Chart({
        el: this.$refs.chart,
        pixelRatio: window.devicePixelRatio
      })
      this.$emit("init", this.chart)
    }
  }
}

</script>